
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.915 12.275c-.048 0-.048-.05-.048-.05v-.048l-.926-.097-.195.097c-.049 0-.049 0-.049-.049l-.048-.146.195-.438s0-.049.048-.049l1.413-.341c0-.292-.049-1.851-.195-2.436-.048-.244-.146-.487-.195-.633-.097-.244-.146-.39-.146-.634-.292 0-.682-.048-.828-.048l-.097.34c0 .05-.05.05-.05.05h-.438s-.048 0-.048-.05c0 0-.098-.146-.147-.438L.484 7.11l-.195.244H.241s-.049 0-.049-.049L.143 7.11l.146-.487v-.39c0-.097.05-.243.195-.243s4.483-.146 4.629-.195l.097-.049c-.049-.195-.097-.828.098-1.023h-.244c-.292 0-.39-.049-.39-.098 0-.097.098-.146.536-.146h.292c.05-.097.098-.292.195-.292s.147.146.195.292h.439c.292 0 .39.05.39.098 0 .097-.098.146-.536.146H5.99c.097.097.195.244.195.585.048.048.048.097.048.243.195-.049.536-.097.634-.146 0-.244.146-1.51.243-1.949.146-.487.244-.73.439-.73.146 0 .292.243.438.73.098.439.244 1.705.244 1.949.146 0 .487.097.633.146 0-.097 0-.195.049-.243 0-.341.097-.488.195-.585h-.195c-.487 0-.536-.049-.536-.146 0-.098.097-.098.39-.098h.438c.049-.097.098-.292.195-.292s.146.146.195.292h.292c.487 0 .536.05.536.146 0 .098-.097.098-.39.098H9.79c.195.244.097.828.097 1.023v.098c.146 0 4.483.146 4.629.194.146 0 .195.195.195.244v.438l.146.439-.098.195s0 .049-.048.049h-.05l-.194-.244-4.677.195a1.207 1.207 0 01-.146.438l-.049.049h-.439c-.048 0-.048 0-.048-.049l-.098-.34c-.146 0-.536.048-.828.048 0 .195-.097.39-.146.633-.049.195-.146.39-.195.634-.146.584-.195 2.143-.195 2.436l1.413.34s.049 0 .049.05l.195.39-.05.194c0 .049-.048.049-.048.049l-.195-.049h-.974v.049c0 .049-.049.049-.049.049H6.915z"}})])
          )
        }
      }
    